import { Typography } from "@mui/material";
import React from 'react';

const Orders = () => (
  <div>
    <Typography variant="h4" gutterBottom>Welcome to Orders Page</Typography>
    <Typography>This is the Orders Page content.</Typography>
  </div>
);

export default Orders;
